import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'

import { Outlet } from 'react-router-dom'

const Dashboard = (Props) => {

  const {}=Props

  return (
    <>
    
    </>
  );
}


export default Dashboard